import { ApiClientProps } from "hooks/useApi";
import { LocationDetailsProps } from "./getLocationDetails";

interface UpdateTableStatusEnabledProps {
  tableStatusEnabled: boolean;
  locationDetails: LocationDetailsProps;
  partnerId?: string;
  apiClient: ApiClientProps;
}

async function updateTableStatusEnabled({
  tableStatusEnabled,
  locationDetails,
  partnerId,
  apiClient,
}: UpdateTableStatusEnabledProps) {
  if (!locationDetails || !partnerId) {
    throw new Error(
      "Network failure. Please check your connection and ensure your request includes a valid locationDetails parameter."
    );
  }

  const updatedLocationDetails = {
    ...locationDetails,
    tableStatusEnabled,
  };

  const body = JSON.stringify(updatedLocationDetails);

  try {
    const response = await apiClient.put({
      path: `/middleware-admin/partners/${partnerId}/locations/${locationDetails.id}`,
      headers: {
        "Content-Type": "application/json",
      },
      body,
      noRetry: true,
    });

    return response;
  } catch (error) {
    throw new Error(error as string);
  }
}

export default updateTableStatusEnabled;
